import styled from 'styled-components'
import { SPACING, WIDTH } from '../constants'

const LineLimitContainer = styled.div`
  max-width: ${WIDTH.LINE_LIMIT};
  padding-top: ${SPACING.S};
`
export default LineLimitContainer
